import React, { useState, useEffect } from 'react'
import FilterLazeCutting from './FilterLazeCutting'
import { Pagination } from 'antd'
import LazeCuttingTable from './table/LazeCuttingTable'
import { getListBatchesCutting, exportBatchesCutting } from '../../../services/api/3dApi'
import { _convertObject } from "../../../helpers/convertObject"
import moment from "moment"
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import { NavLink } from 'react-router-dom'
import { getUserRoles } from '../../../services/AuthServices'
import { createJobExport } from '../../../helpers/createJobExport'
import UseDebounce from '../../users/helpers/UseDebounce'


const ListLazeCuttingPage = (props) => {

    const { setIsLaze, isLaze } = props
    const [listBatches, setListBatches] = useState([])
    const [name, setName] = useState('')
    const [productTypes, setProductTypes] = useState([])
    const [usersCut, setUsersCut] = useState([])
    const [receivedUsers, setReceivedUsers] = useState([])
    const [startCuttingAt, setStartCuttingAt] = useState("")
    const [receivedLaserAt, setReceivedLaserAt] = useState("")
    const [userCreate, setUserCreate] = useState('')
    const [tags, setTags] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const debounceUserCreate = userCreate === '' ? UseDebounce(userCreate, 0) : UseDebounce(userCreate, 500)


    const _handleChangeProductType = value => {
        setProductTypes(value)
        setPage(1)
    }

    const _handleChangeUsersCut = value => {
        setUsersCut(value)
        setPage(1)
    }

    const _handleChangeReceivedUsers = value => {
        setReceivedUsers(value)
        setPage(1)
    }

    const _handleChangeDate = (field, filter) => {
        if (field === 'created_at') {
            setStartCuttingAt({ ...filter })
        } else if (field === 'receivedLaserAt') {
            setReceivedLaserAt({ ...filter })
        }
        setPage(1)
    }

    const _handleChangeInput = (field, value) => {
        if (field === 'user_create') setUserCreate(value)
        if (field === 'name') setName(value)
        setPage(1)
    }

    const _handleChangeSelect = (field, value) => {
        if (field === 'tags') setTags(value)
        setPage(1)
    }

    const _handlePageChange = page => {
        setPage(page)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    const refreshLazeCut = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page, limit, name, productTypes, cutter_name: usersCut, received_laser_user: receivedUsers
            }

            if (startCuttingAt.created_at) {
                payload.startCuttingAt = startCuttingAt.created_at.date
                payload.startCuttingAtTime = startCuttingAt.created_at.time
            }
            if(receivedLaserAt.receivedLaserAt) {
                payload.receivedLaserAt = receivedLaserAt.receivedLaserAt
            }
            if (userCreate) payload.user_create = userCreate
            if (tags && tags.length) payload.tags = tags

            const { data: results } = await getListBatchesCutting(payload)
            const { data, success, error } = Object.assign({}, results)

            if (!success) return setError(error)

            const { batches, total } = data
            setListBatches(batches)
            setTotal(total)
            setLoading(false)

        } catch (error) {
            setError(error)
        }
    }

    const _exportAllItemBatches = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                productTypes,
                cutter_name: usersCut,
                received_laser_user: receivedUsers,
                name: name
            }

            if (startCuttingAt.created_at) {
                payload.startCuttingAt = startCuttingAt.created_at.date
                payload.startCuttingAtTime = startCuttingAt.created_at.time
            }
            if(receivedLaserAt.receivedLaserAt) {
                payload.receivedLaserAt = receivedLaserAt.receivedLaserAt
            }
            if (userCreate) payload.user_create = userCreate
            if (tags && tags.length) payload.tags = tags

            const newFilter = _convertObject(payload)

            const { data: res } = await exportBatchesCutting(newFilter)
            if (typeof res !== 'string') {
                const { success, message: mess, data } = res
                if (!success) throw new Error(mess)

                if (Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            } else {
                if (res) downloadFileFromData(res, { filename: `items_batches_cut-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

        } catch (e) {
            setError(e.message)
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        refreshLazeCut()

    }, [page, limit, name, productTypes, startCuttingAt, receivedLaserAt, usersCut, receivedUsers, debounceUserCreate, tags])

    // @FAC-26042: chỉ Admin (Super Admin, fac_admin, ffm_admin) thấy nút Export item và cột số item
    const adminRole = getUserRoles().some(role => ['Super Admin', 'fac_admin', 'ffm_admin'].includes(role.name))

    return (
        <div className="ListLazeCuttingPage">
            <div className="container-fluid min-vh-100">
                <div className="col-12 mx-auto bg-white shadow-sm py-3 px-0 px-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className="m-0">Danh sách cắt laze</h3>
                        </div>
                        <div>
                            {adminRole &&
                                <button type="button" className="ant-btn ant-btn-primary mx-4" onClick={_exportAllItemBatches}><span>Export item</span></button>
                            }

                            <button type="button" className="ant-btn bg-white">
                                <NavLink exact to='/laze-cutting' className='nav-link p-0'>
                                    Đánh dấu cắt laze
                                </NavLink>
                            </button>
                        </div>
                    </div>

                    <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                        <FilterLazeCutting
                            productTypes={productTypes}
                            onChangeProductType={_handleChangeProductType}
                            usersCut={usersCut}
                            onChangeUsersCut={_handleChangeUsersCut}
                            receivedUsers={receivedUsers}
                            onChangeReceivedUsers={_handleChangeReceivedUsers}
                            loading={loading}
                            handleChangeDate={_handleChangeDate}
                            handleChangeInput={_handleChangeInput}
                            handleChangeSelect={_handleChangeSelect}
                            userCreate={userCreate}
                            tags={tags}
                            dateValue={{
                                "created_at": startCuttingAt,
                                "receivedLaserAt": receivedLaserAt
                            }}
                        />
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && (
                                <div className="text-danger mb-2">{error}</div>
                            )}
                        </div>
                        <Pagination current={page} total={total} pageSize={limit}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onChange={_handlePageChange}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={_handleShowSizeChange} />
                    </div>

                    <div className="LazeCuttingTable">
                        <LazeCuttingTable
                            listBatches={listBatches}
                            loading={loading}
                            onChangeProductType={_handleChangeProductType}
                            adminRole={adminRole}
                        />
                    </div>

                    <Pagination
                        current={page} total={total} pageSize={limit}
                        onChange={_handlePageChange}
                        showQuickJumper
                        className='CustomPagination text-right' showSizeChanger
                        pageSizeOptions={['10', '20', '50', '100']}
                        onShowSizeChange={_handleShowSizeChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default ListLazeCuttingPage